<script src="../../api/user.js"></script>
<template>
  <div class="addList">
    <div class="addListTit">
      <span>申请材料</span>
      <el-checkbox
        :indeterminate="isIndeterminate"
        v-model="checkAll"
        @change="meterialCheckAllChange">全选</el-checkbox>
    </div>
    <div
      class="addListCb"
      id="task_list_check">
      <ul>
        <el-checkbox-group
          v-model="checkedMeterial"
          @change="meterialCheckedChange">
          <li
            v-for="item in cloudDiskData"
            :key="item">
            <el-checkbox :label="item"> {{ item.file_name }}</el-checkbox>
          </li>
        </el-checkbox-group>
      </ul>
    </div>
    <div class="addListFot">
      <el-button
        type="primary"
        size="small"
        :disabled="checkedMeterial.length === 0"
        @click="meterialSave">保存</el-button>
    </div>
  </div>
</template>
<script>
  let AllChecked = [];
  export default {
    props: {
      cloudDiskData: {
        type: Array,
        default() {
          return {};
        },
      }
    },
    data() {
      return {
        checkAll: false,  // 默认全选按钮是否选中
        checkList: [], // 数据存放
        checkedMeterial: AllChecked, // 设置默认选中
        isIndeterminate: false, // 表示checkbox的不确定状态，一般用于实现全选的效果
      };
    },
    mounted() {
    },
    methods: {
      /*
       * 初始化数据
       * */
      getDiskInfo(id) {
        this.$emit('loading-refresh', true);
        this.$http._post({
          url: `/index/student/cloudDisk/userid/${id}`,
          data: {
            qcrb: this.$route.name.indexOf('qcrb_') > -1
          }
        }).then((response) => {
          this.$emit('loading-refresh', false);
          this.$emit('refresh-cloud-data', response.data);
          this.$message.success('保存成功');
        }).catch(() => {
          this.$router.replace({ name: 'studentIndex' });
        });
      },
      /*
       * 全选操作
       * */
      meterialCheckAllChange(val) {
        AllChecked = [];
        this.cloudDiskData.forEach((item) => {
          AllChecked.push(item);
        });
        this.checkedMeterial = val ? AllChecked : [];
        this.isIndeterminate = false;
      },
      /*
       * 单选操作
       * */
      meterialCheckedChange(value) {
        const checkedCount = value.length;
        this.checkAll = checkedCount === this.cloudDiskData.length;
        this.isIndeterminate = checkedCount > 0 &&
          checkedCount < this.cloudDiskData.length;
      },
      /*
       * 材料保存
       * */
      meterialSave() {
        this.$http._post({
          url: '/index/cloud_disk/setFiles',
          data: this.checkedMeterial
        }).then(() => {
          if (this.checkedMeterial.length !== 0) {
            this.getDiskInfo(this.$route.params.id);
          } else {
            this.$message.error('没有数据可保存');
          }
          this.checkedMeterial = [];
          this.isIndeterminate = false;
          this.$emit('dialog-disk-visible', false);
        }).catch(() => {
          this.$message.error('保存失败');
        });
      },
      /*
       * 清空 关闭数组
       * */
      closeMeterial() {
        this.checkedMeterial = [];
        this.isIndeterminate = false;
      }
    },
  };
</script>
<style src="../../assets/css/common-pc.css"></style>
<style>
  .addList {
    background-color:#fff;
    position:relative;
  }
  .addList h3 {
    color:#3368fa;
    font-size:18px;
    margin:0
  }
  .addListTit {
    width:100%;
    height:35px;
    line-height:35px;
    background-color:#c7d1da;
    font-size:14px;
    font-weight:bold;
    color:#575757;
    border:1px solid #d1d6d9
  }
  .addListTit span{
    margin-left:5px
  }
  .addListTit input[type='checkbox']{
    float:left;
    margin-top:12px;
    margin-left:15px
  }
  .addListCb{
    width:100%;
    height:auto;
    overflow:hidden
  }
  .addListCb ul{
    overflow:hidden;
    border-left:1px solid #d1d6d9
  }
  .addListCb ul li {
    width: 33.3333%;
    float:left;
    padding-left: 10px;
    height:30px;
    line-height:30px;
    color:#6a6a6a;
    font-size:14px;
    border-right:1px solid #d1d6d9;
    border-bottom:1px solid #d1d6d9
  }
  .addListCb ul li input[type='checkbox']{
    float:left;
    margin-top:10px
  }
  .addListCb ul li span {
    display: inline-block;
    vertical-align: middle;
    overflow:hidden;
    max-width:200px;
    white-space:nowrap;
    text-overflow:ellipsis
  }
  .addListCb ul li span:last-child{
    padding-right:10px;
  }
  .addListFot {
    margin-top:20px;
  }

</style>
